import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  public accountForm: UntypedFormGroup;
  public permissionForm: UntypedFormGroup;
  public active = 1;

  constructor(private formBuilder: UntypedFormBuilder) {
    const perfStart = performance.now();
    console.log('🚀 [PERFORMANCE] CreateUserComponent constructor - INICIO');
    
    const accountFormStart = performance.now();
    this.createAccountForm();
    console.log('👤 [PERFORMANCE] createAccountForm() completado en:', (performance.now() - accountFormStart).toFixed(2), 'ms');
    
    const permissionFormStart = performance.now();
    this.createPermissionForm();
    console.log('🔐 [PERFORMANCE] createPermissionForm() completado en:', (performance.now() - permissionFormStart).toFixed(2), 'ms');
    
    console.log('✅ [PERFORMANCE] CreateUserComponent constructor - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

  createAccountForm() {
    const perfStart = performance.now();
    console.log('👤 [PERFORMANCE] createAccountForm() - INICIO');
    
    this.accountForm = this.formBuilder.group({
      fname: [''],
      lname: [''],
      email: [''],
      password: [''],
      confirmPwd: ['']
    });
    
    console.log('✅ [PERFORMANCE] createAccountForm() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }
  
  createPermissionForm() {
    const perfStart = performance.now();
    console.log('🔐 [PERFORMANCE] createPermissionForm() - INICIO');
    
    this.permissionForm = this.formBuilder.group({
    });
    
    console.log('✅ [PERFORMANCE] createPermissionForm() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

  ngOnInit() {
    const perfStart = performance.now();
    console.log('🚀 [PERFORMANCE] CreateUserComponent.ngOnInit() - INICIO');
    
    // Cualquier inicialización adicional aquí
    
    console.log('✅ [PERFORMANCE] CreateUserComponent.ngOnInit() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

}
